<template>
  <div class="bind_account">
    <component :is="comName" :isLogin="false" :weixininfo="wxData.weixininfo" @loginSuccess="loginSuccess" @changeWxBindCom="changeWxBindCom"/>
  </div>
</template>

<script>
import ValiCodeCom from './ValiCodeCom.vue'
import PhoneCom from './PhoneCom.vue'
export default {
  name: 'WorkspaceJsonWxBind',
  props: {
    wxData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      comName: 'ValiCodeCom',
    }
  },
  components: {
    ValiCodeCom,
    PhoneCom,
  },
  mounted() {},

  methods: {
    loginSuccess(res) {
      this.$emit('loginSuccess', res)
    },
    changeWxBindCom(com){
      this.comName = com
    }
  },
}
</script>

<style lang="less" scoped>
.bind_account {
  display: flex;
  .left {
    flex: 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .img_box {
      width: 134px;
      height: 134px;
      padding: 3px;
      border: 1px solid #ccc;
      border-radius: 50%;
      > img {
        width: 100%;
        height: 100%;
        border: 1px solid #ccc;
        border-radius: 50%;
      }
    }
    .nickname {
    }
  }
  .right {
    flex: 6;
    .nav_list {
      position: relative;
      display: flex;
      justify-content: center;
      border-bottom: 2px solid #ccc;
      .nav_item {
        padding-bottom: 23px;
        margin-right: 28px;
        font-size: 17px;
        cursor: pointer;
        &:last-child {
          margin: 0;
        }
      }
      .activeItem {
        color: #0a2565;
        font-weight: bold;
        border-bottom: 4px solid #0a2565;
      }
    }
  }
}
</style>
